/**
 * 元码科技 API 配置
 * 文档：https://www.anqicms.com/api-guide/10563.html
 */
export const anqicmsConfig = {
  /** API 根路径，开发环境可走 vue.config.js 代理为 /api */
  apiBase: process.env.VUE_APP_ANQICMS_API_BASE || '/api',
  /** 是否启用远程 API（未配置后端地址时使用本地 mock 数据） */
  enabled: process.env.VUE_APP_ANQICMS_ENABLED !== 'false',
  /** Banner 分组类型，对应 /api/banner/list 的 type 参数，默认 default */
  bannerType: process.env.VUE_APP_ANQICMS_BANNER_TYPE || 'default',
  /** 解决方案页 Banner 分组类型 */
  solutionsBannerType: process.env.VUE_APP_ANQICMS_SOLUTIONS_BANNER_TYPE || 'solutions',
  /** 导航类型 ID，对应 /api/nav/list 的 type_id 参数，默认 1 */
  navTypeId: Number(process.env.VUE_APP_ANQICMS_NAV_TYPE_ID) || 1,
  /** 文档模型 ID，对应 /api/archive/list 的 moduleId，新闻/文章一般为 1 */
  moduleId: process.env.VUE_APP_ANQICMS_MODULE_ID
    ? Number(process.env.VUE_APP_ANQICMS_MODULE_ID)
    : undefined
}

export function isAnqicmsEnabled() {
  return anqicmsConfig.enabled && Boolean(anqicmsConfig.apiBase)
}
